import LayoutDefault from './LayoutDefault'

export default LayoutDefault
